// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"1026b7d3","299":"f31339ee","343":"b946d54a","787":"fec03637"}[chunkId] + ".chunk.js";
};